class SimilarProduct extends HTMLElement {
  constructor() {
    super();
    this.variantChangeHandler = this.variantChangeHandler.bind(this);
    this.cta = this.querySelector("dialog-toggle button");
    this.sizeLabel = this.querySelector('[data-target="size"]');
    this.locale = this.getAttribute("data-locale");
    this.localePrefix = this.getAttribute("data-locale-prefix") || "";
    this.initializeNostoLocalization = this.initializeNostoLocalization.bind(this);
    this.localizeRecommendationLinks = this.localizeRecommendationLinks.bind(this);

    const similarItemsContainer = this.querySelector("#pdp-similar-products");
    const observer = new MutationObserver((mutationsList, observer) => {
      this.triggerVariantChange();
      this.localizeRecommendationLinks();
      observer.disconnect();
    });

    const observeConfig = {
      attributes: true,
      childList: true,
    };

    observer.observe(similarItemsContainer, observeConfig);
  }

  triggerVariantChange() {
    setTimeout(() => {
      this.variantChangeHandler();
    }, 200);
  }

  localizeRecommendationLinks() {
    const container = this.querySelector("#pdp-similar-products");
    if (!container || !this.localePrefix) {
      return;
    }

    container.querySelectorAll("a[href]").forEach((link) => {
      let productUrl;

      try {
        productUrl = new URL(link.href, window.location.origin);
      } catch {
        return;
      }

      const productPath = productUrl.pathname.replace(/^\/+/, "");
      if (!productPath.startsWith("products/")) {
        return;
      }

      const localizedPath = `${this.localePrefix}/${productPath}`;
      if (productUrl.pathname !== `/${localizedPath}`) {
        productUrl.pathname = `/${localizedPath}`;
        link.href = productUrl.href;
      }
    });
  }

  initializeNostoLocalization() {
    if (!this.locale || typeof window.nostojs !== "function") {
      return;
    }

    window.nostojs((api) => {
      api.setLanguage(this.locale);
      api.loadRecommendations();
    });
  }

  connectedCallback() {
    document.addEventListener("variant-change", this.variantChangeHandler);
    this.initializeNostoLocalization();

    if (!this.locale || typeof window.nostojs === "function") {
      return;
    }

    window.addEventListener("load", this.initializeNostoLocalization, { once: true });
  }

  variantChangeHandler(event) {
    const crtEvent = !event && this.lastEvent ? this.lastEvent : event;
    if (event) this.lastEvent = crtEvent;

    const { options, available } = crtEvent.detail || {};
    const { Size: size } = options || {};
    this.cta.classList.add("hidden");

    if (size == null || available) {
      return;
    }

    if (this.sizeLabel) this.sizeLabel.textContent = size;
    let hasMatchingSize = false;

    this.querySelectorAll("[data-sizes]").forEach((item) => {
      const sizes = item
        .getAttribute("data-sizes")
        ?.split(",")
        .map((s) => s.trim());

      if (sizes && sizes.includes(String(size))) {
        item.classList.remove("hidden");
        hasMatchingSize = true;
      } else {
        item.classList.add("hidden");
      }
    });

    if (hasMatchingSize) {
      this.cta.classList.remove("hidden");
    }
  }

  disconnectedCallback() {
    document.removeEventListener("variant-change", this.variantChangeHandler);
  }
}

customElements.define("similar-products", SimilarProduct);
